import $ from 'jquery';
import FJBase from './FJBase';
import FJDomUtil from '../../../util/FJDomUtil';

class FJTextShadowOutline extends FJBase {
    constructor(props) {
        super(props);

        props = props || {};
        this._name = 'FJOutline';
        this._width = typeof props.width != 'undefined' ? props.width : 1; // 文字描边宽度
        this._widthRef = typeof props.widthRef != 'undefined' ? props.widthRef : 1000; // 文字描边宽度的参考
        this._color = (props && props.color) || '#000000'; // 文字描边颜色
        this._offset = typeof props.offset != 'undefined' ? props.offset : 0; // 偏移距离，比例值
        this._angle = typeof props.angle != 'undefined' ? props.angle : 45; // 偏移角度
        this._textColor = (props && props.textColor) || ''; // 文字颜色

        this._position = (props && props.position) || 'absolute';
    }

    encode() {
        return {
            name: this._name,
            width: this._width,
            color: this._color,
            textColor: this._textColor,
            offset: this._offset,
            angle: this._angle,
        };
    }
    decode(data) {
        this._width = data.width;
        this._color = data.color;
        this._textColor = data.textColor;
        this._offset = data.offset;
        this._angle = data.angle;
    }
    clone() {
        let object = new FJTextShadowOutline();
        object.decode(this);

        return object;
    }
    get name() {
        return this._name;
    }

    set width(width) {
        this._width = width;
    }
    get width() {
        return this._width;
    }

    set color(color) {
        this._color = color;
    }
    get color() {
        return this._color;
    }

    /**
     * 将style应用到
     * @param view
     * @param {[]} textData
     * @param {{}} options
     */
    addToView(view, textData, options) {
        if (!view) return;

        super.addToView(view, textData, options);
        this._layer2 = this._layer.cloneNode(true);

        $(this._layer2).css({
            position: 'relative',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
        });

        const {
            supportLayer,
            supportAllAnimationLayer,
            isAddToSupportLayer = false,
            isOnlyUpdateSupportLayer = false,
        } = options;
        if (supportAllAnimationLayer && supportLayer) {
            supportAllAnimationLayer.appendChild(this._layer);
            if (!supportLayer.parentNode) {
                $(view).parent().before(supportLayer);
            }
        }

        if (isAddToSupportLayer) {
            $(this._layer2).css({
                position: 'absolute',
            });
            supportAllAnimationLayer.appendChild(this._layer2);
        } else {
            if (isOnlyUpdateSupportLayer) {
                return;
            }
            view.appendChild(this._layer2);
        }
    }

    /**
     * @override
     * @return {*[]} - [[span, ...], [span, ...]]
     */
    getTextLayers() {
        let list = [];
        [this._layer, this._layer2].forEach(layer => {
            let lineLayers = this._getLineLayersWithLayer(layer);
            if (lineLayers && lineLayers.length > 0) {
                let textLayers = [];
                for (let i = 0; i < lineLayers.length; i++) {
                    let line = lineLayers[i];
                    let spans = $(line).find('span.fl-text-animation');
                    const spansArray = Array.from(spans);
                    textLayers = textLayers.concat(spansArray);

                    // TODO 记录每个span所在的行，用于部分特殊的动画，可以考虑优化
                    spansArray.forEach(span => {
                        span.__TEXT_ANIMATION_LAYER__ = i;
                    });
                }
                list.push(textLayers);
            }
        });

        return list;
    }

    /**
     * 更新文字某一行文字样式
     * @param styleData
     * @param lineIdx
     */
    updateStyle(styleData, lineIdx) {
        if (!this._layer) return;
        let lineLayer = $(this._layer).find('div');
        let lineLayer2 = $(this._layer2).find('div');

        let fontSize = parseFloat(styleData.fontSize);
        let ref = (0.1 * fontSize * this.offset) / 100;
        let x = ref * Math.cos((this.angle / 180) * Math.PI);
        let y = ref * Math.sin((this.angle / 180) * Math.PI);

        // 描边改成内描边，宽度统一x3
        // let width = (fontSize * this._width * 3) / this._widthRef;
        if (lineIdx < lineLayer.length) {
            let ele = lineLayer[lineIdx];
            let ele2 = lineLayer2[lineIdx];
            if (this._textColor) {
                $(ele).css({
                    ...styleData,
                    color: this._textColor,
                });
                $(ele2).css({
                    ...styleData,
                    color: this._textColor,
                });
            } else {
                $(ele).css(styleData);
                $(ele2).css(styleData);
            }
        }

        let width = (fontSize * this._width * 1.5) / this._widthRef;
        $(this._layer).css({
            'text-shadow': this._getTextStroke(this._color, width),
            transform: 'translate(' + x + 'px,' + y + 'px)',
        });
        $(this._layer2).css({
            'text-shadow': 'unset',
            'text-stroke': 'unset',
            transform: 'translate(' + x + 'px,' + y + 'px)',
        });

        // $(this._layer).css({
        //     '-webkit-text-stroke': width + 'px ' + this._color,
        //     'text-stroke': width + 'px ' + this._color,
        //     transform: 'translate(' + x + 'px,' + y + 'px)',
        // });
        // $(this._layer2).css({
        //     'text-stroke': 'unset',
        //     transform: 'translate(' + x + 'px,' + y + 'px)',
        // });
    }

    _getTextStroke(color, width) {
        const r = width;
        const n = Math.ceil(2 * Math.PI * r); /* number of shadows */
        let str = '';
        for (let i = 0; i < n; i++ /* append shadows in n evenly distributed directions */) {
            const theta = (2 * Math.PI * i) / n;
            str += r * Math.cos(theta) + 'px ' + r * Math.sin(theta) + 'px 0 ' + color + (i === n - 1 ? '' : ',');
        }
        return str;
    }

    /**
     * @desc 更新所有行文字文字样式
     * @param styleData
     */
    updateAllLineStyle(styleData) {
        if (!this._layer) return;
        let lineLayer = $(this._layer).find('div');
        let lineLayer2 = $(this._layer2).find('div');

        let fontSize = parseFloat(styleData.fontSize);
        let ref = (0.1 * fontSize * this.offset) / 100;
        let x = ref * Math.cos((this.angle / 180) * Math.PI);
        let y = ref * Math.sin((this.angle / 180) * Math.PI);

        // 描边改成内描边，宽度统一x3
        // let width = (fontSize * this._width * 3) / this._widthRef;

        for (let i = 0; i < lineLayer.length; i++) {
            let ele = lineLayer[i];
            let ele2 = lineLayer2[i];
            if (this._textColor) {
                $(ele).css({
                    ...styleData,
                    color: this._textColor,
                });
                $(ele2).css({
                    ...styleData,
                    color: this._textColor,
                });
                // 找到 span 设置为 this._textColor, TODO 找到有文字的span设置（优化）
                FJDomUtil.updateSpanTextNodeColor(ele, this._textColor);
                FJDomUtil.updateSpanTextNodeColor(ele2, this._textColor);
            } else {
                $(ele).css(styleData);
                $(ele2).css(styleData);
            }
        }

        let width = (fontSize * this._width * 1.5) / this._widthRef;
        $(this._layer).css({
            'text-shadow': this._getTextStroke(this._color, width),
            transform: 'translate(' + x + 'px,' + y + 'px)',
        });
        $(this._layer2).css({
            'text-shadow': 'unset',
            'text-stroke': 'unset',
            transform: 'translate(' + x + 'px,' + y + 'px)',
        });

        // $(this._layer).css({
        //     '-webkit-text-stroke': width + 'px ' + this._color,
        //     'text-stroke': width + 'px ' + this._color,
        //     transform: 'translate(' + x + 'px,' + y + 'px)',
        // });
        // $(this._layer2).css({
        //     'text-stroke': 'unset',
        //     transform: 'translate(' + x + 'px,' + y + 'px)',
        // });
    }

    updatePadding(padding) {
        super.updatePadding(padding);

        if (!this._layer2) return;

        $(this._layer2).css(padding);
    }

    isEqual(style) {
        return style.width === this._width && style.color === this._color;
    }

    clear() {
        if (this._layer && this._layer.parentNode) {
            this._layer.parentNode.removeChild(this._layer);
        }
        if (this._layer2 && this._layer2.parentNode) {
            this._layer2.parentNode.removeChild(this._layer2);
        }
    }
}

export default FJTextShadowOutline;
